import anewSignIn from '@/utils/anewSignIn';
import { getMessage } from '@/utils/notice';
import { AxiosError } from 'axios';

export class IgnoreError extends Error {
  constructor() {
    super('忽略错误');
  }
}

let networkErrorTimer: ReturnType<typeof setTimeout> | null = null;
let rateLimitTimer: ReturnType<typeof setTimeout> | null = null;

function showNetworkError() {
  if (networkErrorTimer) return;
  getMessage().error('网络异常');
  networkErrorTimer = setTimeout(() => {
    networkErrorTimer = null;
  }, 2000);
}

function showRateLimitError() {
  if (rateLimitTimer) return;
  getMessage().warning('操作过于频繁，请稍后再试');
  rateLimitTimer = setTimeout(() => {
    rateLimitTimer = null;
  }, 2000);
}

export function handleRequestError(error: AxiosError<any>) {
  const { response } = error;
  if (response) {
    switch (response.status) {
      case 401: {
        anewSignIn('身份验证失败，请重新登录');
        break;
      }
      case 429:
      case 430:
      case 439: {
        showRateLimitError();
        break;
      }
      default: {
        getMessage().error(response.data?.message || '请求失败');
        break;
      }
    }
  } else {
    showNetworkError();
  }
}

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason instanceof IgnoreError) {
    event.stopImmediatePropagation();
    event.preventDefault();
  } else if (event.reason?.isAxiosError) {
    handleRequestError(event.reason);
  }
});
